import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import {rootReducer} from "./rootReducer";
import { setupListeners } from "@reduxjs/toolkit/query";
import { setStore } from "./storeaccessor";
// Configuration du store Redux
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,

        }).concat(apiSlice.middleware),
    devTools: true,
})
// Configuration des listeners de RTK Query pour la gestion du focus / reconnect

setupListeners(store.dispatch);

setStore(store);
// Typage de `dispatch` et `state`
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export type AppStore = typeof store;
